/**
 * 시스템 역할 상수
 *
 * ROLE_NAME(authority)은 이 파일 하나에서 관리한다.
 * 역할명이 바뀌어도 이 파일만 수정하면 된다.
 *
 * DB 기준:
 *   R0 → ROLE_SUPER_ADMIN (슈퍼관리자)
 *   R1 → ROLE_ADMIN       (일반관리자)
 *   R2 → ROLE_COMP_ADMIN  (고객사관리자)
 *   R3 → ROLE_USER        (고객사일반사원)
 */

export const ROLES = {
  SUPER_ADMIN: "ROLE_SUPER_ADMIN",
  ADMIN:       "ROLE_ADMIN",
  COMP_ADMIN:  "ROLE_COMP_ADMIN",
  USER:        "ROLE_USER",
};

/** 역할 코드 → 한국어 표시명 매핑 */
export const ROLE_DISPLAY = {
  [ROLES.SUPER_ADMIN]: "슈퍼관리자",
  [ROLES.ADMIN]:       "일반관리자",
  [ROLES.COMP_ADMIN]:  "고객사관리자",
  [ROLES.USER]:        "고객사일반사원",
};

/** 역할 선택 옵션 배열 (Account 화면 등 select/dropdown 용) */
export const ROLE_OPTIONS = [
  { value: "R0", label: ROLE_DISPLAY[ROLES.SUPER_ADMIN] },
  { value: "R1", label: ROLE_DISPLAY[ROLES.ADMIN] },
  { value: "R2", label: ROLE_DISPLAY[ROLES.COMP_ADMIN] },
  { value: "R3", label: ROLE_DISPLAY[ROLES.USER] },
];
